import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import {
  Col,
  Row,
  Card,
  CardBody,
  Nav,
  NavItem,
  NavLink,
  Collapse,
} from "reactstrap";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import Config from "config";
import { FiChevronUp, FiChevronDown } from "react-icons/fi";
import { makeSelectStyles } from "../../common/selectStyles";

function NewDocumentationGenerale() {
  const backUrl = Config.backOffice.url;
  const api = Config.backOffice.apiName;
  const navigate = useNavigate();
  const layout = localStorage.getItem("layoutMode");

  const [loading, setLoading] = useState(true);
  const [wait, setWait] = useState(1000);
  const token = localStorage.getItem("auth_token_" + api);
  const [activeTab, setActiveTab] = useState("details");
  const [isIdentificationAccordionOpen, setIsIdentificationAccordionOpen] =
    useState(true);
  const toggleIdentificationAccordion = () => {
    setIsIdentificationAccordionOpen(!isIdentificationAccordionOpen);
  };

  const styles = makeSelectStyles(layout);

  // Formulaire vide
  const [formData, setFormData] = useState({
    Nom: "",
    Catégorie: { label: null, value: null },
    Type: { label: null, value: null },
    Année: { label: null, value: null },
    Fichier: null,
  });

  const handleInputChange = (key, value) => {
    setFormData((prevState) => ({ ...prevState, [key]: value }));
    if (key === "Catégorie" && value?.value) {
      getTypes(value.value);
    }
  };

  // les options des selects
  const [categoriesData, setCategoriesData] = useState({ data: [] });
  const [typesData, setTypesData] = useState({ data: [] });
  const [anneesData, setAnneesData] = useState({ data: [] });

  const renderSelectOptions = (data) => [
    {
      options: data.map((item) => ({
        label: item.label,
        value: item.value ?? item.id,
      })),
    },
  ];

  const getCategories = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/documentation_generales/categories_documents`, {
        headers: { Authorization: `Bearer ${token}` },
      })
        .then((response) => response.json())
        .then((result) => {
          setCategoriesData(result);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const getTypes = async (categoriesDocumentId) => {
    try {
      fetch(`https://www.fluxod.com/${api}/documentation_generales/types_documents?categories_document_id=${categoriesDocumentId}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
        .then((response) => response.json())
        .then((result) => {
          setTypesData(result);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const getAnnees = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/documentation_generales/annees`, {
        headers: { Authorization: `Bearer ${token}` },
      })
        .then((response) => response.json())
        .then((result) => {
          setAnneesData(result);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const handleNavigate = (newId) => {
    localStorage.setItem("key", true);
    const previousPath = localStorage.getItem("previousPath_" + api);
    navigate(previousPath || -1);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      setLoading(true);
      const body = new FormData();
      body.append("nom", formData["Nom"]);
      body.append("categories_document_id", formData["Catégorie"]?.value);
      body.append("types_document_id", formData["Type"]?.value);
      body.append("annee_id", formData["Année"]?.value);
      if (formData["Fichier"])
        body.append("fichier", formData["Fichier"]);

      const response = await fetch(
        `https://www.fluxod.com/${api}/documentation_generales`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body,
        }
      );

      if (response.ok) {
        const responseData = await response.json();
        handleNavigate(responseData?.id);
      } else {
        const responseData = await response.json();
        if (responseData?.message_validation) {
          responseData.message_validation.forEach((err) => toast.error(err));
        } else {
          toast.error("Une erreur s'est produite");
        }
        setLoading(false);
      }
    } catch (error) {
      console.error("An error occurred", error);
      toast.error("Une erreur s'est produite");
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        await getCategories();
        await getAnnees();
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  document.title = "Documentation générale | Nouveau";

  const CustomNavTabs = () => {
    const navStyle = {
      cursor: "pointer",
      borderRadius: "0px",
      whiteSpace: "nowrap",
    };
    return (
      <Nav pills className="navtab-bg nav-justified custom-nav-tabs">
        <NavItem>
          <NavLink
            style={navStyle}
            className={`nav-link ${activeTab === "details" ? "active" : ""}`}
            onClick={() => setActiveTab("details")}
          >
            Nouveau document
          </NavLink>
        </NavItem>
      </Nav>
    );
  };

  const fieldStyle = {
    backgroundColor: "white",
    transition: "all 0.15s ease",
    borderLeft: "3px solid transparent",
    position: "relative",
  };

  return (
    <>
      <React.Fragment>
        <div className="page-content" style={{ fontFamily: "sans-serif" }}>
          <div className="container-fluid">
            <Row>
              <Col lg="12">
                <Card>
                  <CardBody className="border-bottom">
                    <div className="d-flex align-items-center">
                      <h5
                        className="mb-0 card-title flex-grow-1"
                        style={{ fontWeight: "bold", display: "flex" }}
                      >
                        <Link
                          to={`${backUrl}/documentation_generales/`}
                          style={{
                            color: "#555B21",
                            textDecoration: "underline !important",
                          }}
                        >
                          Documentation générale
                        </Link>
                        <i className="bx bx-caret-right"></i>
                        Nouveau
                      </h5>
                    </div>
                    <div className="d-flex justify-content-end">
                      <div className="d-flex align-items-end">
                        <button
                          className="btn btn-sm btn-primary"
                          onClick={handleSubmit}
                        >
                          <i className="bx bx-send"></i> Valider
                        </button>
                        &nbsp;&nbsp;
                        <button
                          onClick={() => {
                            const previousPath = localStorage.getItem("previousPath_" + api);
                            navigate(previousPath || -1);
                          }}
                          className="btn btn-sm btn-soft-secondary"
                          style={{ width: "88.43px" }}
                        >
                          <i className="bx bx-arrow-back"></i> Annuler
                        </button>
                      </div>
                    </div>
                  </CardBody>
                  {CustomNavTabs()}
                  <CardBody>
                    {activeTab === "details" && (
                      <div>
                        {!loading ? (
                          <>
                            <Row>
                              <Col sm="12">
                                <Card
                                  className="shadow-sm border-0 overflow-hidden mb-4"
                                  style={{ borderRadius: "12px" }}
                                >
                                  <div
                                    className="px-2 py-2 text-white fw-semibold d-flex align-items-center justify-content-between"
                                    style={{
                                      background: "#555B21",
                                      letterSpacing: "0.5px",
                                      cursor: "pointer",
                                      userSelect: "none",
                                    }}
                                    onClick={toggleIdentificationAccordion}
                                  >
                                    <span style={{ fontSize: "0.82rem" }}>
                                      Identification
                                    </span>
                                    {isIdentificationAccordionOpen ? (
                                      <FiChevronUp size={16} />
                                    ) : (
                                      <FiChevronDown size={16} />
                                    )}
                                  </div>

                                  <Collapse isOpen={isIdentificationAccordionOpen}>
                                    <CardBody className="p-0">
                                      <div className="fields-container" style={{ paddingBottom: "8px" }}>
                                        {/* Nom */}
                                        <div
                                          className="field-item px-2 py-1"
                                          style={fieldStyle}
                                          onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor = "#e3f2fd";
                                            e.currentTarget.style.borderLeftColor = "#007bff";
                                          }}
                                          onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor = "white";
                                            e.currentTarget.style.borderLeftColor = "transparent";
                                          }}
                                        >
                                          <Row className="align-items-center g-1">
                                            <Col xs={12} md={12} lg={4} className="field-label">
                                              <div className="d-flex align-items-center small text-muted" style={{ minWidth: 0, gap: "4px" }}>
                                                <span
                                                  className="fw-medium"
                                                  style={{
                                                    fontSize: "0.7rem",
                                                    letterSpacing: "0.2px",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "nowrap",
                                                    minWidth: 0,
                                                    flex: "1 1 auto",
                                                    display: "block",
                                                  }}
                                                  title="Nom"
                                                >
                                                  Nom
                                                </span>
                                                <span className="text-primary" style={{ flexShrink: 0, marginLeft: "auto" }}>:</span>
                                              </div>
                                            </Col>
                                            <Col xs={12} md={12} lg={8}>
                                              <input
                                                className="form-control form-control-sm"
                                                type="text"
                                                value={formData["Nom"]}
                                                onChange={(e) =>
                                                  handleInputChange("Nom", e.target.value)
                                                }
                                              />
                                            </Col>
                                          </Row>
                                        </div>

                                        {/* Catégorie */}
                                        <div
                                          className="field-item px-2 py-1"
                                          style={fieldStyle}
                                          onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor = "#e3f2fd";
                                            e.currentTarget.style.borderLeftColor = "#007bff";
                                          }}
                                          onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor = "white";
                                            e.currentTarget.style.borderLeftColor = "transparent";
                                          }}
                                        >
                                          <div
                                            className="field-separator"
                                            style={{
                                              position: "absolute",
                                              top: "0",
                                              left: "0",
                                              right: 0,
                                              height: "1px",
                                              background:
                                                "linear-gradient(90deg, #e9ecef 0%, #e9ecef 20%, #e9ecef 100%, #e9ecef 100%)",
                                            }}
                                          />
                                          <Row className="align-items-center g-1">
                                            <Col xs={12} md={12} lg={4} className="field-label">
                                              <div className="d-flex align-items-center small text-muted" style={{ minWidth: 0, gap: "4px" }}>
                                                <span
                                                  className="fw-medium"
                                                  style={{
                                                    fontSize: "0.7rem",
                                                    letterSpacing: "0.2px",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "nowrap",
                                                    minWidth: 0,
                                                    flex: "1 1 auto",
                                                    display: "block",
                                                  }}
                                                  title="Catégorie"
                                                >
                                                  Catégorie
                                                </span>
                                                <span className="text-primary" style={{ flexShrink: 0, marginLeft: "auto" }}>:</span>
                                              </div>
                                            </Col>
                                            <Col xs={12} md={12} lg={8}>
                                              <Select
                                                styles={styles(false)}
                                                value={formData["Catégorie"]?.value ? formData["Catégorie"] : null}
                                                onChange={(val) =>
                                                  handleInputChange("Catégorie", val)
                                                }
                                                options={renderSelectOptions(categoriesData.data)}
                                                classNamePrefix="select2-selection"
                                                menuPortalTarget={document.body}
                                                isClearable
                                                placeholder="Sélectionner..."
                                              />
                                            </Col>
                                          </Row>
                                        </div>

                                        {/* Type */}
                                        <div
                                          className="field-item px-2 py-1"
                                          style={fieldStyle}
                                          onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor = "#e3f2fd";
                                            e.currentTarget.style.borderLeftColor = "#007bff";
                                          }}
                                          onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor = "white";
                                            e.currentTarget.style.borderLeftColor = "transparent";
                                          }}
                                        >
                                          <div
                                            className="field-separator"
                                            style={{
                                              position: "absolute",
                                              top: "0",
                                              left: "0",
                                              right: 0,
                                              height: "1px",
                                              background:
                                                "linear-gradient(90deg, #e9ecef 0%, #e9ecef 20%, #e9ecef 100%, #e9ecef 100%)",
                                            }}
                                          />
                                          <Row className="align-items-center g-1">
                                            <Col xs={12} md={12} lg={4} className="field-label">
                                              <div className="d-flex align-items-center small text-muted" style={{ minWidth: 0, gap: "4px" }}>
                                                <span
                                                  className="fw-medium"
                                                  style={{
                                                    fontSize: "0.7rem",
                                                    letterSpacing: "0.2px",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "nowrap",
                                                    minWidth: 0,
                                                    flex: "1 1 auto",
                                                    display: "block",
                                                  }}
                                                  title="Type"
                                                >
                                                  Type
                                                </span>
                                                <span className="text-primary" style={{ flexShrink: 0, marginLeft: "auto" }}>:</span>
                                              </div>
                                            </Col>
                                            <Col xs={12} md={12} lg={8}>
                                              <Select
                                                styles={styles(false)}
                                                value={formData["Type"]?.value ? formData["Type"] : null}
                                                onChange={(val) =>
                                                  handleInputChange("Type", val)
                                                }
                                                options={renderSelectOptions(typesData.data)}
                                                classNamePrefix="select2-selection"
                                                menuPortalTarget={document.body}
                                                isClearable
                                                placeholder="Sélectionner..."
                                              />
                                            </Col>
                                          </Row>
                                        </div>

                                        {/* Année */}
                                        <div
                                          className="field-item px-2 py-1"
                                          style={fieldStyle}
                                          onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor = "#e3f2fd";
                                            e.currentTarget.style.borderLeftColor = "#007bff";
                                          }}
                                          onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor = "white";
                                            e.currentTarget.style.borderLeftColor = "transparent";
                                          }}
                                        >
                                          <div
                                            className="field-separator"
                                            style={{
                                              position: "absolute",
                                              top: "0",
                                              left: "0",
                                              right: 0,
                                              height: "1px",
                                              background:
                                                "linear-gradient(90deg, #e9ecef 0%, #e9ecef 20%, #e9ecef 100%, #e9ecef 100%)",
                                            }}
                                          />
                                          <Row className="align-items-center g-1">
                                            <Col xs={12} md={12} lg={4} className="field-label">
                                              <div className="d-flex align-items-center small text-muted" style={{ minWidth: 0, gap: "4px" }}>
                                                <span
                                                  className="fw-medium"
                                                  style={{
                                                    fontSize: "0.7rem",
                                                    letterSpacing: "0.2px",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "nowrap",
                                                    minWidth: 0,
                                                    flex: "1 1 auto",
                                                    display: "block",
                                                  }}
                                                  title="Année"
                                                >
                                                  Année
                                                </span>
                                                <span className="text-primary" style={{ flexShrink: 0, marginLeft: "auto" }}>:</span>
                                              </div>
                                            </Col>
                                            <Col xs={12} md={12} lg={8}>
                                              <Select
                                                styles={styles(false)}
                                                value={formData["Année"]?.value ? formData["Année"] : null}
                                                onChange={(val) =>
                                                  handleInputChange("Année", val)
                                                }
                                                options={renderSelectOptions(anneesData.data)}
                                                classNamePrefix="select2-selection"
                                                menuPortalTarget={document.body}
                                                isClearable
                                                placeholder="Sélectionner..."
                                              />
                                            </Col>
                                          </Row>
                                        </div>

                                        {/* Fichier */}
                                        <div
                                          className="field-item px-2 py-1"
                                          style={fieldStyle}
                                          onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor = "#e3f2fd";
                                            e.currentTarget.style.borderLeftColor = "#007bff";
                                          }}
                                          onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor = "white";
                                            e.currentTarget.style.borderLeftColor = "transparent";
                                          }}
                                        >
                                          <div
                                            className="field-separator"
                                            style={{
                                              position: "absolute",
                                              top: "0",
                                              left: "0",
                                              right: 0,
                                              height: "1px",
                                              background:
                                                "linear-gradient(90deg, #e9ecef 0%, #e9ecef 20%, #e9ecef 100%, #e9ecef 100%)",
                                            }}
                                          />
                                          <Row className="align-items-center g-1">
                                            <Col xs={12} md={12} lg={4} className="field-label">
                                              <div className="d-flex align-items-center small text-muted" style={{ minWidth: 0, gap: "4px" }}>
                                                <span
                                                  className="fw-medium"
                                                  style={{
                                                    fontSize: "0.7rem",
                                                    letterSpacing: "0.2px",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "nowrap",
                                                    minWidth: 0,
                                                    flex: "1 1 auto",
                                                    display: "block",
                                                  }}
                                                  title="Fichier"
                                                >
                                                  Fichier
                                                </span>
                                                <span className="text-primary" style={{ flexShrink: 0, marginLeft: "auto" }}>:</span>
                                              </div>
                                            </Col>
                                            <Col xs={12} md={12} lg={8}>
                                              <input
                                                className="form-control form-control-sm"
                                                type="file"
                                                accept=".pdf,.doc,.docx,.xls,.xlsx"
                                                onChange={(e) =>
                                                  handleInputChange(
                                                    "Fichier",
                                                    e.target.files[0] || null
                                                  )
                                                }
                                              />
                                            </Col>
                                          </Row>
                                        </div>
                                      </div>
                                    </CardBody>
                                  </Collapse>
                                </Card>
                              </Col>
                            </Row>
                          </>
                        ) : (
                          <Spinners setLoading={setLoading} setWait={wait} />
                        )}
                      </div>
                    )}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
        </div>
        <ToastContainer />
      </React.Fragment>
    </>
  );
}

export default NewDocumentationGenerale;
